export const APP_AUTH_TOKEN = 'auth_token';
export const APP_USER_INFO = 'app_user_info';
export const THIRDPARTY_PATH = '/static/framework/thirdparty';
export const CONST_DATE_TIME_FORMATER = 'YYYY-MM-DD HH:mm:ss';
export const CONST_DATE_TIME_MINUTE_FORMATER = 'YYYY-MM-DD HH:mm';
